define.alias("shared/modifiers/animate-typewriter", "settings/modifiers/animate-typewriter");